import _aiWidgetProviderQuery from "./__generated__/aiWidgetProviderQuery.graphql";
import React, { Fragment, useMemo } from 'react';
import { graphql, usePreloadedQuery } from 'react-relay';
import { HubErrorBoundary, useHubContext } from '@atlassian/company-hub-common';
import { handleChatBubbleVariant, handleWidgetButtonVariant, handleWidgetPosition, handleWidgetRadiusType, handleWidgetSpaceType } from '../../common/utils';
import { AiWidgetConfigProvider } from '../ai-widget-config-context';
/**
 * Provides AI widget config via context when available.
 * On query failure or invalid data, it falls back to rendering children only.
 */
var AiWidgetProviderInner = function AiWidgetProviderInner(_ref) {
  var _data$helpCenter;
  var queryReference = _ref.queryReference,
    children = _ref.children;
  var _useHubContext = useHubContext(),
    siteId = _useHubContext.cloudId;
  var data = usePreloadedQuery(_aiWidgetProviderQuery, queryReference);
  var primaryColor = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
  var widgetConfig = data.csmAi_getSupportWidget;
  var supportWidgetConfig = useMemo(function () {
    if (!widgetConfig || !widgetConfig.id || !widgetConfig.theme || !primaryColor || !siteId) {
      return null;
    }
    return {
      siteId: siteId,
      widgetId: widgetConfig.id,
      widgetTheme: {
        primaryColor: primaryColor,
        radius: handleWidgetRadiusType(widgetConfig.theme.radius),
        space: handleWidgetSpaceType(widgetConfig.theme.space),
        chatBubbleVariant: handleChatBubbleVariant(widgetConfig.theme.chatColor),
        widgetButtonVariant: handleWidgetButtonVariant(widgetConfig.theme.colorVibeVariant),
        attribution: null
      },
      widgetPosition: handleWidgetPosition(widgetConfig.position),
      isEnabled: Boolean(widgetConfig.isEnabled)
    };
  }, [widgetConfig, primaryColor, siteId]);
  if (!supportWidgetConfig) {
    return /*#__PURE__*/React.createElement(Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(AiWidgetConfigProvider, {
    supportWidgetConfig: supportWidgetConfig
  }, children);
};
export var AiWidgetProvider = function AiWidgetProvider(_ref2) {
  var queryReference = _ref2.queryReference,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(HubErrorBoundary, {
    packageName: "@atlassian/csm-ai-search-trigger",
    id: "AiWidgetProvider",
    fallback: /*#__PURE__*/React.createElement(Fragment, null, children)
  }, /*#__PURE__*/React.createElement(AiWidgetProviderInner, {
    queryReference: queryReference
  }, children));
};